export default __webpack_public_path__ + "c7b1a470791ccabff7b1e2158b1ad53e.png";